var w = Object.defineProperty;
var d = Object.getOwnPropertySymbols;
var N = Object.prototype.hasOwnProperty, P = Object.prototype.propertyIsEnumerable;
var O = (e, r, n) => r in e ? w(e, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[r] = n, t = (e, r) => {
  for (var n in r || (r = {}))
    N.call(r, n) && O(e, n, r[n]);
  if (d)
    for (var n of d(r))
      P.call(r, n) && O(e, n, r[n]);
  return e;
};
var c = (e, r) => {
  var n = {};
  for (var s in e)
    N.call(e, s) && r.indexOf(s) < 0 && (n[s] = e[s]);
  if (e != null && d)
    for (var s of d(e))
      r.indexOf(s) < 0 && P.call(e, s) && (n[s] = e[s]);
  return n;
};
import { jsxs as z, jsx as i } from "react/jsx-runtime";
import o from "../../../node_modules/prop-types/index.es.js";
import { forwardRef as B, useId as F } from "react";
import * as H from "./style.es.js";
import { Base as M, StartIcon as U, EndIcon as V, Input as Z, Label as v } from "./style.es.js";
import { INPUT_VARIANT as x } from "../../../constants/inputVariant.es.js";
import { Helper as D } from "../../DataDisplay/Helper/Helper.es.js";
import { COMPONENT_SIZE as j } from "../../../constants/sizes.es.js";
const f = B((J, L) => {
  var y = J, {
    block: e,
    className: r,
    endIcon: n,
    error: s,
    helperProps: C,
    helperText: k,
    id: u,
    inputProps: E = {},
    label: l,
    maxLength: b,
    name: S,
    onChange: _,
    rounded: A,
    size: p = j.md,
    startIcon: $,
    success: g,
    value: a = "",
    variant: m = x.standard
  } = y, h = c(y, [
    "block",
    "className",
    "endIcon",
    "error",
    "helperProps",
    "helperText",
    "id",
    "inputProps",
    "label",
    "maxLength",
    "name",
    "onChange",
    "rounded",
    "size",
    "startIcon",
    "success",
    "value",
    "variant"
  ]);
  const I = F(), T = E, {
    className: R
  } = T, q = c(T, [
    "className"
  ]);
  return /* @__PURE__ */ z(M, { className: r, $block: e, $variant: m, $error: s, $success: g, $size: p, $rounded: A, $hasLabel: !!l, $disabled: h.disabled, children: [
    $ && /* @__PURE__ */ i(U, { $variant: m, $size: p, children: $ }),
    n && /* @__PURE__ */ i(V, { $variant: m, $size: p, children: n }),
    /* @__PURE__ */ i(Z, t(t({ ref: L, id: u || I, name: S, value: a, placeholder: " ", onChange: _, maxLength: b, className: R }, h), q)),
    l && /* @__PURE__ */ i(v, { htmlFor: u || I, children: l }),
    /* @__PURE__ */ i(D, t({ text: k, error: s, success: g, maxLength: b, size: p }, t({
      counter: a == null ? void 0 : a.length
    }, C)))
  ] });
}), G = {
  block: o.bool,
  className: o.string,
  disabled: o.bool,
  endIcon: o.oneOfType([o.string, o.node]),
  error: o.bool,
  helperProps: o.any,
  helperText: o.oneOfType([o.string, o.node]),
  id: o.string,
  inputProps: o.any,
  label: o.oneOfType([o.string, o.node]),
  loading: o.bool,
  maxLength: o.number,
  name: o.string,
  onChange: o.func,
  onClick: o.func,
  rounded: o.bool,
  size: o.oneOf(Object.values(j)),
  startIcon: o.oneOfType([o.string, o.node]),
  success: o.bool,
  value: o.string,
  variant: o.oneOf(Object.values(x))
};
f.S = H;
f.displayName = "Input";
f.propTypes = G;
export {
  f as Input,
  G as inputPropTypes
};
//# sourceMappingURL=Input.es.js.map
